import {
  ICompaniesViewState,
  initialCompaniesViewState,
} from '@myStore/companies/view/companies-view.state';
import {
  CompaniesViewActions,
  ECompaniesViewActions,
} from '@myStore/companies/view/companies-view.actions';

export const companiesViewReducers = (
  state = initialCompaniesViewState,
  actions: CompaniesViewActions
): ICompaniesViewState => {
  switch (actions.type) {
    case ECompaniesViewActions.GetCompaniesRequest:
      return {
        ...state,
        companies: { data: null, isLoading: true, errors: null },
      };
    case ECompaniesViewActions.GetCompaniesSuccess:
      return {
        ...state,
        isLoading: false,
        companies: { data: actions.companies, isLoading: false, errors: null },
      };
    case ECompaniesViewActions.GetCompaniesFailure:
      return {
        ...state,
        isLoading: false,
        companies: { data: null, isLoading: false, errors: actions.error },
      };
    case ECompaniesViewActions.ClearCompanies:
      return {
        ...state,
        companies: {
          data: null,
          isLoading: false,
          errors: null,
        },
      };

    case ECompaniesViewActions.GetGraduatesRequest:
      return {
        ...state,
        graduates: { data: null, count: 0, isLoading: true, errors: null },
      };
    case ECompaniesViewActions.GetGraduatesSuccess:
      return {
        ...state,
        isLoading: false,
        graduates: {
          data: actions.graduates,
          count: actions.graduates.count,
          isLoading: false,
          errors: null,
        },
      };
    case ECompaniesViewActions.GetGraduatesFailure:
      return {
        ...state,
        isLoading: false,
        graduates: {
          data: null,
          count: 0,
          isLoading: false,
          errors: actions.error,
        },
      };
    case ECompaniesViewActions.ClearGraduates:
      return {
        ...state,
        graduates: {
          data: null,
          count: 0,
          isLoading: false,
          errors: null,
        },
      };

    case ECompaniesViewActions.GetVacanciesRequest:
      return {
        ...state,
        vacancies: { data: null, count: 0, isLoading: true, errors: null },
      };
    case ECompaniesViewActions.GetVacanciesSuccess:
      return {
        ...state,
        isLoading: false,
        vacancies: {
          data: actions.vacancies,
          count: actions.vacancies.count,
          isLoading: false,
          errors: null,
        },
      };
    case ECompaniesViewActions.GetVacanciesFailure:
      return {
        ...state,
        isLoading: false,
        vacancies: {
          data: null,
          count: 0,
          isLoading: false,
          errors: actions.error,
        },
      };
    case ECompaniesViewActions.ClearVacancies:
      return {
        ...state,
        vacancies: {
          data: null,
          count: 0,
          isLoading: false,
          errors: null,
        },
      };
    default:
      return state;
  }
};
